import React from 'react';
import { Breadcrumb, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { ExamTable, PaymentTable } from "../../components/Tables";
import { CustomerFilter } from '../../components/Filters';
import { useState } from 'react';
import { PaymentFilter } from '../../components/Modals';



export default () => {
    const [filter, setFilter] = useState({});
    const [refreshState, setRefreshState] = useState("");

    return (
        <div className="justify-content-between flex-wrap flex-md-nowrap py-4">
            <div className="mb-4 mb-lg-0">
                <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
                    <Breadcrumb.Item><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
                    <Breadcrumb.Item>Configurações</Breadcrumb.Item>
                    <Breadcrumb.Item active>Mét. Pagamentos</Breadcrumb.Item>

                </Breadcrumb>

                <Row className="d-flex flex-wrap flex-md-nowrap align-items-center py-4">
                    <Col className="d-block mb-4 mb-md-0">
                        <h1 className="h2">Consulta de Mét. Pagamentos</h1>
                        <p className="mb-0">
                            Tabela contendo todos os métodos de pagamento cadastrados.
                        </p>
                    </Col>
                </Row>
                <PaymentFilter setFilter={setFilter} refreshState={refreshState} setRefreshState={setRefreshState} />
                <PaymentTable refreshState={refreshState} setRefreshState={setRefreshState} />
            </div>
        </div >
    );
};
